module.exports = __webpack_public_path__ + "img/date-start_new.f9e2053d.svg";